/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, Stack, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../libs/Context';
import { useSelector } from 'react-redux';
import MainCard from '../../../../../../../UiComponents/Cards/MainCard';

const SocialMedia = (props) =>
{
	const { createFeedAs, selectedMedia, setSelectedMedia, requestT, socialAccounts, isSocialEnable } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state.mysession.session);

	const handleCheck = (apiKey) =>
	{
		let updatedArr = [];

		if (apiKey === 'All')
		{
			updatedArr = selectedMedia?.length === socialAccounts?.length ? [] : socialAccounts?.map((each) => each?.name);
		}
		else
		{
			updatedArr = selectedMedia?.includes(apiKey) ? selectedMedia?.filter((each) => each !== apiKey) : [ ...selectedMedia, apiKey ];
		}
		setSelectedMedia(updatedArr);
	};

	const socialMediaImgs = {
		facebook  : '/images/icons/SquareFb.svg',
		linkedIn  : '/images/icons/SquareLinkedIn.svg',
		instagram : '/images/icons/SquareInsta.svg',
		twitter   : '/images/icons/SquareTwitter.svg'
	};

	return (
		<>
			{isSocialEnable && socialAccounts?.length > 0 &&
			<Grid item xs={12} >
				<MainCard sx={{ borderRadius: '13px', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px' }}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Stack direction={'column'}>
								<FormControlLabel
									sx={{
										'& .MuiFormControlLabel-label' : {
											fontSize   : 'var(--pixel16)',
											fontWeight : 500,
											color      : '#8F8F8F'
										}
									}}
									label={language.socialMedia}
									control={
										<Checkbox
											checked={selectedMedia?.length === socialAccounts?.length}
											indeterminate={selectedMedia?.length > 0 && selectedMedia?.length !== socialAccounts?.length}
											onChange={() => handleCheck('All')}
										/>
									}
								/>
								<Typography variant='body2' fontWeight='var(--font500)' color={'var(--txtColorBlackL)'}>
									{language.selectDesiredChannels}
								</Typography>
							</Stack>
						</Grid>
						<Grid item xs={12}>
							<Grid container direction={'row'} spacing={1} alignItems={'center'} px='var(--pixel8)'>
								{socialAccounts?.map((socialData) => (
									<Grid item key={socialData.apiKey}>
										<FormControlLabel
											label={
												<img src={socialMediaImgs[socialData.apiKey]} alt={socialData.apiKey} height={'var(--pixel30)'} width={'var(--pixel30)'} />
											}
											control={
												<Checkbox
													checked={selectedMedia.includes(socialData?.name)}
													onChange={() => handleCheck(socialData?.name)}
												/>
											}
										/>
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</MainCard>
			</Grid>

			}
		</>
	);
};

export default SocialMedia;